import React from 'react';
const testimonials = [{
  quote: 'Am venit la Teodora simțindu-mă complet pierdută. Prin R.I.S.E. am reușit să îmi pun ordine în gânduri și să fac primii pași spre o carieră care chiar îmi place, fără să mă mai judec atât de aspru.',
  author: 'Maria, 26 ani'
}, {
  quote: 'Structura programului a fost exact ce aveam nevoie. Nu doar discuții, ci planuri concrete. Am învățat să îmi gestionez frica de eșec și să acționez chiar și când nu mă simt 100% pregătit.',
  author: 'Andrei, 30 ani'
}, {
  quote: 'Comunitatea este minunată. Să vezi că și alți tineri trec prin aceleași blocaje îți ia o piatră de pe inimă. Teodora ghidează totul cu o blândețe și o claritate extraordinare.',
  author: 'Elena, 24 ani'
}];
export function Testimonials() {
  return <section className="bg-rise-white text-rise-black py-14 md:py-[120px] px-6" data-id="element-190">
      <div className="max-w-rise-content mx-auto" data-id="element-191">
        <div className="text-center mb-16" data-id="element-192">
          <h2 className="font-playfair text-[32px] md:text-[38px] mb-4" data-id="element-193">
            Ce spun tinerii care au lucrat cu mine.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-194">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 md:p-[40px] rounded-xl border border-gray-200 shadow-sm flex flex-col" data-id="element-195">
              <div className="text-rise-gold mb-6" data-id="element-196">
                <svg width="32" height="24" viewBox="0 0 32 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-197">
                  <path d="M13.4667 13.6C13.4667 19.4667 9.2 24 3.86667 24C1.73333 24 0 22.2667 0 20.1333C0 18 1.73333 16.2667 3.86667 16.2667C4.66667 16.2667 5.33333 16.5333 6 16.9333C6.4 15.6 6.66667 14.1333 6.66667 12.6667C6.66667 8.53333 4.26667 4.93333 0.666667 3.2L3.33333 0C8.93333 2.53333 13.4667 7.73333 13.4667 13.6ZM32 13.6C32 19.4667 27.7333 24 22.4 24C20.2667 24 18.5333 22.2667 18.5333 20.1333C18.5333 18 20.2667 16.2667 22.4 16.2667C23.2 16.2667 23.8667 16.5333 24.5333 16.9333C24.9333 15.6 25.2 14.1333 25.2 12.6667C25.2 8.53333 22.8 4.93333 19.2 3.2L21.8667 0C27.4667 2.53333 32 7.73333 32 13.6Z" data-id="element-198" />
                </svg>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed mb-8 flex-grow italic" data-id="element-199">
                "{testimonial.quote}"
              </p>
              <div className="font-dm-sans font-semibold text-[15px] text-rise-gold" data-id="element-200">
                {testimonial.author}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}